import { createAction } from '@reduxjs/toolkit';

export const CHECK_SMS_QUEUE_SESSION_TYPE = 'saga/checkSmsQueueSession';
export const checkSmsQueueSessionAction = createAction(CHECK_SMS_QUEUE_SESSION_TYPE);
